<ng-container *transloco="let t; read: 'user'">
<div>
  <div>
    <div class="flex justify-between">
      <drdp-title [title]="formStep === step.StepOne ? t('dashboard.portfolio.addEvidence.titleAdd') : t('dashboard.portfolio.addEvidence.titlePreliminary')"></drdp-title>
      <drdp-btn color="outline" (click)="back()">{{ t('dashboard.portfolio.addEvidence.goBack') }}</drdp-btn>
    </div>
    <h1 class="mb-2 mt-0 text-1xl leading-tight"><b>{{ t('dashboard.portfolio.ratingPeriodLabel') }}</b> {{ params && params.ratingPeriodName }}
  </h1>
  <h2 class="mb-2 mt-0 text-1xl leading-tight"><b>{{ t('dashboard.portfolio.addEvidence.classroomLabel') }}</b> {{ params && params.classroomName }}</h2>
  <h2 class="mb-2 mt-0 text-1xl leading-tight"><b>{{ t('dashboard.portfolio.addEvidence.ageGroupInstrumentLabel') }}</b> {{params &&
params.ageGradeInstrumentName }}</h2>
<h2 class="mb-2 mt-0 text-1xl leading-tight"><b>{{ t('dashboard.portfolio.addEvidence.childrenLabel') }}</b> {{ studentNames }}</h2>
@if (formStep === step.StepOne) {
  <div class="mb-2 mt-0 text-1xl text-end">
    <mat-slide-toggle color="primary" class="pr-1" (change)="toggleFutureRatingPeriod()"
      [ngModelOptions]="{ standalone: true }" [attr.aria-label]="t('dashboard.portfolio.addEvidence.sliderToggleAria')">
    </mat-slide-toggle>{{ t('dashboard.portfolio.addEvidence.saveForFutureRatingPeriod') }}
  </div>
}
</div>
@if (formStep === step.StepOne) {
  <drdp-container>
    <div class="p-2 w-full">
      <h1 class="mb-2 font-bold mt-0 text-2xl leading-tight">{{ t('dashboard.portfolio.addEvidence.chooseEvidence') }}</h1>
      <div class="flex justify-evenly">
        @for (evidence of evidences; track evidence; let i = $index) {
          <div class="w-1/6 my-2">
            <div class="tiles mx-auto px-4 pb-4 text-center mb-4" (click)="onTilesClick(i, evidence.type)"
              [class.active]="selectedIndex === i">
              <i class="text-[60px] {{evidence.icon}}"></i>
              <p class="text-[15px]">{{ evidence.name }}</p>
            </div>
            @if (evidence.type != PortfolioEvidenceType.Note) {
              <span class="text-center">
                <p>{{ t('dashboard.portfolio.addEvidence.allowedType') }}</p>
                <p>{{evidence.allowedType}}</p>
              </span>
            }
          </div>
        }
      </div>
    </div>
    @if (selectedIndex != null) {
      <div>
        @if (selectedEvidenceType != PortfolioEvidenceType.Note) {
          <h1 class="mb-2 font-bold pt-5 mt-0 text-1xl leading-tight">{{ t('dashboard.portfolio.addEvidence.addUpload', { type: uploadSettings.uploadText }) }}<b></b>
          </h1>
          <label for="images" class="drop-container" (drop)="fileDropHandler($event)">
            <i class="text-[60px] {{ uploadSettings.uploadIcon }}"></i>
            <span class="drop-title">{{ selectedEvidenceType === PortfolioEvidenceType.Audio
              ? t('dashboard.portfolio.addEvidence.selectFileToUploadAn', { type: uploadSettings.uploadText.toUpperCase() })
              : t('dashboard.portfolio.addEvidence.selectFileToUploadA', { type: uploadSettings.uploadText.toUpperCase() }) }}</span>
            <span class="text-drdpblue-300 text-[15px] underline">{{ t('dashboard.portfolio.addEvidence.dragAndDrop') }}</span>
            <input class="invisible" #addPhotosFileInput type="file" id="images" (change)="onSelectFile($event)"
              accept="{{acceptedFiles}}" [multiple]="allowMultiple" onclick="this.value = null" (click)="onFileClick($event)">
          </label>
          @if (url) {
            <h1 class="mb-2 font-bold pt-5 mt-0 text-1xl leading-tight">{{ t('dashboard.portfolio.addEvidence.uploadedType', { type: uploadSettings.uploadText }) }}<b></b>
            </h1>
          }
          @if (isFileUploading) {
            <h1 class="mb-2 font-bold pt-5 mt-0 text-1xl leading-tight">{{ t('dashboard.portfolio.addEvidence.uploadingProgress', { progress: progress.toFixed(2) }) }}<b></b>
            </h1>
          }
          @if (isFileUploading) {
            <mat-progress-bar mode="determinate"
            value="{{progress.toFixed(2)}}"></mat-progress-bar>
          }
          @if (url) {
            <div class="w-full">
              @if (selectedEvidenceType === PortfolioEvidenceType.Video) {
                <drdp-video
                [url]="displayUrl"></drdp-video>
              }
              @if (selectedEvidenceType === PortfolioEvidenceType.Audio) {
                <drdp-audio
                [url]="displayUrl"></drdp-audio>
              }
              <div class="grid grid-cols-2 gap-4">
                @for (links of files; track links) {
                  <div>
                    <div class="w-fit">
                      @if (selectedEvidenceType === PortfolioEvidenceType.Photo) {
                        <img [src]="links.displayUrl"
                          class="w-full" />
                      }
                      <div class="flex flex-row justify-between">
                        <p class=" text-xs">
                          {{ links.fileName }}
                        </p>
                        <a class=" text-sm text-red-800 cursor-pointer" (click)="onFileRemove(links)">
                          {{ t('dashboard.portfolio.addEvidence.remove') }}
                        </a>
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (selectedEvidenceType != PortfolioEvidenceType.Photo) {
                <div class="flow-root ">
                  <p class="float-left text-xs">
                    {{ displayFileName }}
                  </p>
                  <a class="float-right text-sm text-red-800 cursor-pointer" (click)="onFileRemove()">
                    {{ t('dashboard.portfolio.addEvidence.remove') }}
                  </a>
                </div>
              }
            </div>
          }
        }
        <ng-container>
          <h1 class="mb-2 font-bold pt-8 mt-0 text-1xl leading-tight">{{ t('dashboard.portfolio.addEvidence.addNotes') }}<b></b></h1>
          <textarea rows="10" [(ngModel)]="notes" class="portfolio-textarea w-full" matInput></textarea>
        </ng-container>
        <ng-container>
          <h1 class="mb-2 font-bold pt-5 mt-0 text-1xl leading-tight">{{ t('dashboard.portfolio.addEvidence.assignEvidence') }}<b></b></h1>
          <div class="grid grid-cols-2 md:grid-cols-8 mt-4">
            @if (!isFutureRatingPeriod) {
              @for (domain of templateDomains; track domain) {
                <div class="col-span-1">
                  <h4 class="text-[16px] font-bold mb-2">{{domain.domainCode}}</h4>
                  <mat-checkbox class="font-medium" [checked]="domain.isAllSelected"
                    [(ngModel)]="domain.isAllSelected"
                    (change)="onDomainSelectChange($event.checked, domain)"
                    [ngModelOptions]="{standalone: true}">
                    {{domain.domainCode}}
                  </mat-checkbox>
                  <div class="ml-4">
                    @for (measure of domain.measures; track measure) {
                      <div>
                        <mat-checkbox class="font-medium"
                          (change)="onMeasureSelectChange($event.checked, domain)"
                          [(ngModel)]="measure.isSelected" [ngModelOptions]="{standalone: true}">
                          {{measure.code}}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </div>
              }
            } @else if (isUserState2025Enforced) {
              <h4 class="text-[16px] font-bold my-2 col-span-full">DRDP 2025</h4>
              @for (domain of masterDomains; track domain) {
                <ng-container class="col-span-1">
                  @if (domain.is2025) {
                    <div>
                      <ng-container *ngTemplateOutlet="sharedFutureDomainsContent; context: { $implicit: domain }"></ng-container>
                    </div>
                  }
                </ng-container>
              }
            } @else {
              <h4 class="text-[16px] font-bold my-2 col-span-full">{{ t('dashboard.portfolio.addEvidence.drdp2015') }}</h4>
              @for (domain of masterDomains; track domain) {
                <ng-container class="col-span-1">
                  @if (!domain.onlyPilot && !domain.is2025) {
                    <div>
                      <ng-container *ngTemplateOutlet="sharedFutureDomainsContent; context: { $implicit: domain }"></ng-container>
                    </div>
                  }
                </ng-container>
              }
              <h4 class="text-[16px] font-bold my-2 col-span-full">{{ t('dashboard.portfolio.addEvidence.drdp2025') }}</h4>
              @for (domain of masterDomains; track domain) {
                <ng-container class="col-span-1">
                  @if (domain.is2025) {
                    <div>
                      <ng-container *ngTemplateOutlet="sharedFutureDomainsContent; context: { $implicit: domain }"></ng-container>
                    </div>
                  }
                </ng-container>
              }
            }
            <ng-template #sharedFutureDomainsContent let-domain>
              <h4 class="text-[16px] font-bold mb-2">{{domain.domainCode}}</h4>
              <mat-checkbox class="font-medium" [checked]="domain.isAllSelected"
                [(ngModel)]="domain.isAllSelected"
                (change)="onFutureDomainSelectChange($event.checked, domain)"
                [ngModelOptions]="{standalone: true}">
                {{domain.domainCode}}
              </mat-checkbox>
              <div class="ml-4">
                @for (measure of masterMeasures | filter: 'masterDomainId': domain.id | filter: 'is2025': domain.is2025; track measure) {
                  <div>
                    <mat-checkbox class="font-medium" [checked]="measure.isSelected"
                      (change)="onMeasureSelectChange($event.checked, domain)"
                      [(ngModel)]="measure.isSelected" [ngModelOptions]="{standalone: true}">
                      {{measure.measureCode}}
                    </mat-checkbox>
                  </div>
                }
              </div>
            </ng-template>
          </div>
        </ng-container>
        <div class="w-1/3">
          <drdp-date-picker
            [label]="t('dashboard.portfolio.addEvidence.collectedDate')"
            [isRequired]="true"
            [isReadOnly]="false"
            [minDate]="minStartDate"
            [maxDate]="maxEndDate"
            (emitDate)="handleDate($event)">
          </drdp-date-picker>
        </div>
      </div>
    }
  </drdp-container>
}

@if (formStep === step.StepTwo) {
  <drdp-container additionClasses="min-h-[2rem] mt-4 p-4">
    <h1 class="mb-2 font-bold mt-0 text-2xl leading-tight">{{ t('dashboard.portfolio.addEvidence.assignedEvidence') }} <b></b></h1>
    <p class="helper-text">{{ t('dashboard.portfolio.addEvidence.preliminaryRatingHelp') }}</p>
    <div class="grid grid-cols-3 gap-4">
      <div>
        <label class="font-bold"> {{ t('dashboard.portfolio.addEvidence.selectedStudents') }}</label>
      </div>
      <div>
        <label class="font-bold"> {{ t('dashboard.portfolio.addEvidence.typeEvidence', { type: uploadSettings.uploadText }) }}</label>
      </div>
      <div>
        <label class="font-bold"> {{ t('dashboard.portfolio.addEvidence.preliminaryRating') }}</label>
      </div>
    </div>
    @if (!isFutureRatingPeriod) {
      <div>
        @for (item of addPortfolioModel.evidences; track item; let isLast = $last) {
          <div class="grid grid-cols-3 gap-4"
            [ngClass]="{'border-b': !isLast}">
            <div>
              <div>{{item.name}}</div>
            </div>
            <div>
              @for (measure of item.measures; track measure) {
                <div>
                  <mat-checkbox class="font-medium my-3" [(ngModel)]="measure.isSelected"
                    [ngModelOptions]="{standalone: true}">
                    {{measure.code}}
                  </mat-checkbox>
                </div>
              }
            </div>
            <div>
              @for (measure of item.measures; track measure) {
                <div class="mt-1 mb-3">
                  <drdp-btn color="outline" (click)="openInputRatingModal(measure)">
                    {{ t('dashboard.portfolio.addEvidence.rateMeasure', { measure: measure.code }) }} <i
                  class="text-drdpblue-300 text-xl uil uil-check-circle {{measure.measureValue ? 'text-green-800' : 'text-gray-500'}}"></i></drdp-btn>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (isFutureRatingPeriod) {
      <div class="p-4">
        @for (item of addPortfolioModel.evidences; track item; let isLast = $last) {
          <div
            class="grid grid-cols-3 gap-4 h-full" [ngClass]="{'border-b': !isLast}">
            <div class="flex flex-col justify-start space-y-2 h-full">
              <div>{{item.name}}</div>
            </div>
            <div class="flex flex-col justify-start space-y-2 h-full">
              @for (measure of item.measures; track measure) {
                <div class="my-2">
                  <mat-checkbox class="my-2" [(ngModel)]="measure.isSelected"
                    [ngModelOptions]="{standalone: true}">
                    {{measure.measureCode}}
                  </mat-checkbox>
                </div>
              }
            </div>
            <div class="flex flex-col justify-between space-y-2 h-full">
              @for (measure of item.measures; track measure) {
                <div class="my-2">
                  <drdp-btn [color]="measure.measureId ? 'outline' : 'outlineRed'"
                    (click)="measure.measureId && openInputRatingModal(measure)">
                    @if (measure.measureId) {
                      <span>
                        {{ t('dashboard.portfolio.addEvidence.rateMeasure', { measure: measure.measureCode }) }}
                        <i class="text-drdpblue-300 text-md uil uil-check-circle"
                        [ngClass]="{'text-green-800': measure.measureValue, 'text-gray-200': !measure.measureValue}"></i>
                      </span>
                    } @else {
                      {{ t('dashboard.portfolio.addEvidence.measureNotAvailable', { measure: measure.measureCode }) }}
                    }
                  </drdp-btn>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </drdp-container>
}

<div class="mt-5 mb-20 flex justify-end">
  @if (formStep === step.StepTwo) {
    <drdp-btn class="pr-4" (click)="cancel()" color="cancel" type="button">
      {{ t('dashboard.portfolio.actions.cancel') }}
    </drdp-btn>
  }
  <drdp-btn type="submit" [disabled]="disableSave" class="float-right" (click)="onSaveEvidence()">{{ formStep === step.StepOne
    ? t('dashboard.portfolio.actions.next')
    : t('dashboard.portfolio.actions.save') }}
  </drdp-btn>
</div>
</div>
</ng-container>
